/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react';
import { Modal } from 'antd';
import cn from 'classnames';

export const WithModal = (WrappedComponent) => {
  return (props) => {
    const {
      open,
      onOk,
      onCancel,
      title,
      triggerElement,
      onTrigger,
      centered,
      width,
      destroyOnClose,
      childRef,
      cancelButtonProps,
      okText,
      wrapClassName,
      loading,
      okButtonProps,
      footer,
      closable,
      closeIcon,
      maskClosable,
      ...rest
    } = props;
    const [isOpen, setIsOpen] = React.useState(open);

    const closeModal = () => {
      setIsOpen(false);
    };

    const onClick = () => {
      if (onTrigger) {
        onTrigger();
        return;
      }
      setIsOpen(true);
    };

    const handleCancel = () => {
      if (onCancel) {
        onCancel(closeModal);
        return;
      }
      closeModal();
    };

    const handleOk = () => {
      if (onOk) {
        onOk(closeModal);
        return;
      }
      closeModal();
    };

    useEffect(() => {
      setIsOpen(open);
    }, [JSON.stringify(!!open)]);

    return (
      <React.Fragment>
        {triggerElement ? React.cloneElement(triggerElement, { onClick }) : null}
        <Modal
          closable={closable}
          closeIcon={closeIcon}
          maskClosable={maskClosable}
          title={title}
          width={width}
          open={isOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          keyboard={false} // Prevent closing modal on pressing ESC key
          centered={centered}
          destroyOnClose={destroyOnClose}
          cancelButtonProps={cancelButtonProps}
          okButtonProps={okButtonProps}
          okText={okText}
          wrapClassName={cn('qmas-modal-overlay', wrapClassName)}
          footer={footer}>
          <WrappedComponent ref={childRef} loading={loading} {...rest} />
        </Modal>
      </React.Fragment>
    );
  };
};
